import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

export function bannerHome() {
    const banner = document.querySelector('.banner--home');

    if (!banner) {
        return;
    }

    const bgShape1 = gsap.timeline();
    const bgShape2 = gsap.timeline();
    const bgShapes = gsap.timeline();
    const headingAnim = gsap.timeline();
    const img = gsap.timeline();

    gsap.set('#star-clip path', {
        transformOrigin: '50% 50%'
    });
    gsap.set('#arch-clip path', {
        transformOrigin: '50% 50%'
    });

    headingAnim.to('.reveal', {
        opacity: 1,
        duration: 1
    });

    /* bgShapes.set('.bg-shape', {
        y: 100
    }); */
    bgShapes.to('.bg-shape', {
        scale: 1,
        //y: 0,
        opacity: 1,
        ease: 'elastic.out(0.5,0.5)',
        duration: 3,
        stagger: 0.5
    });
    // Floating
    bgShapes.to('.bg-shape', {
        x: () => gsap.utils.random(-20, 20),
        y: () => gsap.utils.random(-20, 20),
        duration: () => gsap.utils.random(2, 3),
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        stagger: {
            amount: 0.5,
            from: 'random'
        }
    });

    img.to('.img-1', {
        scale: 1,
        opacity: 1,
        ease: 'elastic.out(0.5,0.5)',
        duration: 1
    });
    img.from(
        '#line-1-mask-path',
        {
            duration: 1,
            drawSVG: '0% 0%',
            ease: 'power2.in'
        },
        '>-1.5'
    );
    img.from('#line-2-mask-path', {
        duration: 2,
        drawSVG: '100% 100%',
        ease: 'power2.out'
    });
    img.to(
        '.img-2',
        {
            scale: 1,
            opacity: 1,
            ease: 'elastic.out(0.5,0.5)',
            duration: 1
        },
        '>-1'
    );
    img.to(
        '#star-clip path',
        {
            rotate: 360,
            ease: 'linear',
            duration: 60,
            repeat: -1
        },
        '0'
    );
    img.to(
        '#arch-clip path',
        {
            rotate: -360,
            ease: 'linear',
            duration: 60,
            repeat: -1
        },
        '0'
    );

    gsap.to('.banner__content', {
        opacity: 0,
        y: -200,
        scrollTrigger: {
            trigger: '.banner--home',
            start: 'top top',
            scrub: 2
        }
    });

    // BG shapes scroll
    bgShape1.to('.bg-shape__wrapper-1', {
        y: -100,
        rotate: 60,
        scale: 1.5,
        scrollTrigger: {
            trigger: '.banner--home',
            start: 'top top',
            end: 'bottom top',
            scrub: 2
        }
    });
    bgShape2.to('.bg-shape__wrapper-2', {
        y: -200,
        rotate: -90,
        scale: 1.25,
        scrollTrigger: {
            trigger: '.banner--home',
            start: 'top top',
            end: 'bottom top',
            scrub: 2
        }
    });
}
